import React from 'react';
import cn from 'classnames';
import * as MUI from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { styles } from './styles';
import { Props } from './types';
import ParentExpansion from '../../ParentExpansion';

export const Category = withStyles(styles)(
  class Category extends ParentExpansion<Props> {
    readonly category: React.RefObject<HTMLDivElement>;

    constructor(props) {
      super(props);
      this.category = React.createRef();
    }

    render() {
      const { className, classes } = this.props;
      const { expanded } = this.state;

      return (
        <MUI.ExpansionPanel 
          role='category'
          ref={this.category} 
          classes={classes}
          className={cn(className)} 
          expanded={expanded}>
          {this.boundChildren}
        </MUI.ExpansionPanel>
      );
    }
  })

export default Category;

export * from './CategoryBody';
export * from './CategoryTitle';